export default __webpack_public_path__ + "static/media/simProfile-12.df3e64f7.png";